import Link from "next/link";
import { IIndustry } from "../../typings/filterEntities";
import { industryIconMap } from "../Icons/Icons";
import styles from "./ExploreIndustriesCard.module.css";

interface IIndustryCardProps {
  industry: IIndustry;
  large: boolean;
}

export default function ExploreIndustriesCard({ industry, large }: IIndustryCardProps) {
  const Icon = industryIconMap[industry.slug];

  return (
    <Link href={`/${industry.slug}`} className={large ? styles.root : styles.rootLarge}>
      {Icon && (
        <div className={styles.icon}>
          <Icon width={large ? 48 : 64} height={large ? 48 : 64} />
        </div>
      )}
      <h5 className={large ? styles.label : styles.labelLarge}>{industry.label}</h5>
    </Link>
  );
}
